import { lazy } from 'react';
import { TenantRouteMeta } from '../types';

const TenantSettings = lazy(() => import('../../pages/TenantSettings/TenantSettings'));

// R7: Field Definitions moved to /admin/field-definitions. The tenant route
// is retired — the page file under src/pages/FieldDefinitions/ has been
// deleted and the sidebar group 'field-definitions' removed from
// src/pages/Layout/sidebar/groupsConfig.ts.

export const configurationRoutes: TenantRouteMeta[] = [
  {
    path: 'settings',
    element: <TenantSettings />,
    permission: 'tenant_tab',
    sidebar: { group: 'tenant', label: 'Tenant' },
  },
];
